import { styled } from '@mui/material/styles'
import Switch, { SwitchProps } from '@mui/material/Switch'

const CustomSwitch = styled((props: SwitchProps) => (
  <Switch
    focusVisibleClassName=".Mui-focusVisible"
    disableRipple
    {...props}
  />
))(() => ({
  width: 45,
  boxSizing: 'border-box',
  height: 32,
  padding: 0,
  display: 'flex',
  alignItems: 'center',
  '& .MuiSwitch-switchBase': {
    display: 'flex',
    top: 2,
    width: 28,
    height: 28,
    backgroundColor: 'rgba(176, 177, 184, 0.12)',
    transform: 'translateX(2px)',
    ':hover': {
      backgroundColor: 'rgba(176, 177, 184, 0.12)',
    },

    '&.Mui-checked': {
      transform: 'translateX(15px)',
      backgroundColor: '#4A6BFC',
      ':hover': {
        backgroundColor: '#4A6BFC',
      },
      '& + .MuiSwitch-track': {
        backgroundColor: 'transparent',
        opacity: 1,
      },
    },
  },
  '& .MuiSwitch-thumb': {},
  '& .MuiSwitch-track': {
    borderRadius: 24,
    border: '1px solid rgba(176, 177, 184, 0.12)',
    backgroundColor: 'transparent',
    opacity: 1,
  },
}))

type AppSwitchProps = {
  handleSwitch: () => void
  checked: boolean
}
export const AppSwitch = (props: AppSwitchProps) => {
  const { handleSwitch, checked } = props

  return (
    <CustomSwitch
      checked={checked}
      onChange={handleSwitch}
      icon={
        <span
          style={{
            fontFamily: 'Inter',
            fontSize: '13px',
            fontWeight: 450,
            marginRight: '0px',
            marginBottom: '2px',
          }}
        ></span>
      }
      checkedIcon={
        <span
          style={{
            fontFamily: 'Inter',
            fontSize: '13px',
            fontWeight: 450,
            marginLeft: '2px',
            marginBottom: '2px',
            color: 'red',
          }}
        ></span>
      }
    />
  )
}
